import React from 'react';
import { branch, renderComponent } from 'recompose';
import { Redirect } from 'react-router-dom'

import './Error.css'

const Loading = () => (
    <div style={{textAlign:'center',marginTop:'1rem'}}>Loading....</div>
);

export const withLoadingComponent = branch(
    props => props.loading || !props.loaded,
    renderComponent(Loading)
);

const Error = ({error}) => {

    if(error.response && error.response.status === 401){
        return (<Redirect to="/logout" />);
    }

    return (
        <div className="ErrorBox">
            <div className="Title">Oops!</div>
            <div className="Message">Something went wrong.. please try again in a moment</div>
            <div className="ErrorDetails">{error.message}</div>
        </div>
    )
};


export const withErrorComponent = branch(
    props => props.error,
    renderComponent(Error)
);



// WEBPACK FOOTER //
// ./src/components/loading/index.js